import React, { ReactNode } from "react";
import { BaseAddress, ListingSearchResult } from "redmond";
import "./styles.scss";
import { isCorpTenant } from "@capone/common";
import { config } from "b2b-base/src/api/config";
import { VacationRentalSummaryCard, getImageUrlsArray } from "halifax";
import { OccupancySelection } from "./components/OccupancySelection";
import { CalendarPickerButton } from "./components/CalendarPickerButton";

export interface SelectedVacationRentalSummaryProps {
  selectedHome: ListingSearchResult | null;
  checkIn: Date | null;
  checkOut: Date | null;
  isMobile?: boolean;
  className?: string;
  actions?: ReactNode;
  onUpdateDates?: () => void;
  onUpdateOccupancy?: () => void;
}

export const SelectedVacationRentalSummary = (
  props: SelectedVacationRentalSummaryProps
) => {
  const {
    selectedHome,
    checkIn,
    checkOut,
    onUpdateDates,
    onUpdateOccupancy,
    isMobile,
    className,
    actions,
  } = props;

  const isCorporate = isCorpTenant(config.TENANT);

  if (!selectedHome || !checkIn || !checkOut) return null;
  const [image] = getImageUrlsArray(selectedHome.listing.content.media);

  return (
    <VacationRentalSummaryCard
      checkIn={checkIn}
      checkOut={checkOut}
      isMobile={isMobile}
      className={className}
      actions={actions}
      homeName={selectedHome.listing.content.name}
      homeLocation={
        selectedHome.listing.content.location.address as BaseAddress
      }
      listingCollection={selectedHome.listing.listingCollection}
      calendarComponent={
        !isMobile && !isCorporate ? (
          <CalendarPickerButton
            hasMissingSearchInfoError={false}
            onClickSubmit={onUpdateDates}
            hideSeparator
          />
        ) : undefined
      }
      occupancySelection={
        !isMobile && !isCorporate ? (
          <OccupancySelection onClickSubmit={onUpdateOccupancy} />
        ) : undefined
      }
      displayImage={image}
      numberOfBathrooms={selectedHome.listing.content.layout.numberOfBathrooms}
      numberOfBedrooms={selectedHome.listing.content.layout.numberOfBedrooms}
      maxOccupancy={selectedHome.listing.terms.maxOccupancy}
    />
  );
};
